import { useMatches } from "remix";

export function useIsLoggedIn() {
  const matches = useMatches();

  const matchWithIsLoggedIn = matches.find(
    (match) => match.data?.isLoggedIn === true
  );

  return matchWithIsLoggedIn ? matchWithIsLoggedIn.data.isLoggedIn : false;
}
export function useUsername() {
  const matches = useMatches();

  const matchWithUsername = matches.find(
    (match) => typeof match.data?.username === "string"
  );

  return matchWithUsername ? matchWithUsername.data.username : null;
}
export function useUserRole() {
  const matches = useMatches();

  const matchWithUsername = matches.find(
    (match) => typeof match.data?.userRole === "string"
  );

  return matchWithUsername ? matchWithUsername.data.userRole : null;
}
